var modules_6cfce947 = {"container":"_1lek93p","checked":"_1yxaac1","control":"_1ecq50m","disabled":"_19a1dmk","read-only":"_1dshtc9","input":"_1lues5f","label":"_x098r5","icon":"_gvfqpo"};
import "../../../assets/D3tV1Beg.css";

export { modules_6cfce947 as default };
//# sourceMappingURL=Checkbox.module.less.js.map
